// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__eQM7L","header":"Header_header__QJfsy","shrink":"Header_shrink__+0zNs","wrap":"Header_wrap__L6dTI","nav":"Header_nav__U0G-j","active":"Header_active__Hbh02"};